import {
  TeamManagementOfWarehosues,
  WarehouseInventorySpocModel,
} from "../../../../../erp/inventory/models/inventory_warehouse_spoc_model";
import {
  fetchGet,
  fetchPost,
  fetchPut,
  toQueryString,
} from "../../../../../service/api_client";

export const CreateWarehouseSpocAPI = async (
  data: WarehouseInventorySpocModel,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_management`;
    const res = await fetchPost(url, data);
    return res.data;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};
export const CreateMultiWarehouseSPOCAssigneeAPI = async (
  data: WarehouseInventorySpocModel,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_management/multi-spoc-assignee`;

  const res = await fetchPost(url, data);

  console.log("API response:", res);

  if (res?.success === false) {
    throw new Error(res.error);
  }

  return res;
};

export const GetMultiWarehouseSPOCAssigneeAPI = async () => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_management`;
    const res = await fetchGet(url);

    return res;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};

export const GetWarehosuesForEachMemberAPI = async (search?: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_management/get-warehouses-of-member`;
    const params = search ? { name: search } : {};
    const res = await fetchGet(url + toQueryString(params));

    return res;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};

export const UpdateWarehouseSpocAPI = async (
  data: WarehouseInventorySpocModel,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_management/update`;
    const response = await fetchPut(url, data);
    return response;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};

export const DeleteWarehouseManagerAPI = async (data: {
  warehouse_id: string;
  uid: string;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_management/delete-warehouse-manager`;

    const response = await fetchPut(url, data); // same pattern as update
    return response;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};

export const CreateMultiWarehouseForSameMemberAPI = async (
  data: TeamManagementOfWarehosues,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_management/multi-warehouse-by-member`;

  const res = await fetchPost(url, data);

  console.log("API response:", res);

  if (res?.success === false) {
    throw new Error(res.error);
  }

  return res;
};

export const UpdateSpocWarehousesAPI = async (
  data: TeamManagementOfWarehosues,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_management/update-spocs`;

    const response = await fetchPut(url, data);

    console.log("datsahad:", response);

    return response;
  } catch (error: any) {
    const errData = error?.response?.data;

    throw new Error(
      errData?.error || errData?.message || "Something went wrong",
    );
  }
};
